import { createSlice } from "@reduxjs/toolkit";
import {
  getVendorRemittance,
  getVendorRemittancePaymentReport,
  updateVendorRemittancePayment,
} from "./actions/vendorRemittanceAction.js";

const initialState = {
  vendorRemittance: null,
  totalByVendorRemittance: 0,
  vendorRemittanceFilters: {},
  vendorRemittancePageState: { page: 1, pageSize: 50 },

  vendorRemittancePaymentReport: null,
  totalByVendorRemittancePaymentReport: 0,
  vendorRemittancePaymentReportFilters: {},
  vendorRemittancePaymentReportPageState: { page: 1, pageSize: 50 },
};

export const vendorRemittanceSlice = createSlice({
  name: "remittance",
  initialState,
  reducers: {
    setVendorRemittanceFilters: (state, action) => {
      const { payload } = action;
      state.vendorRemittanceFilters = payload || {};
    },
    resetVendorRemittanceFilters: (state) => {
      state.vendorRemittanceFilters = {};
    },
    setVendorRemittancePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.vendorRemittancePageState = {
          ...state.vendorRemittancePageState,
          page,
        };
      }
      if (pageSize) {
        state.vendorRemittancePageState = {
          ...state.vendorRemittancePageState,
          pageSize,
        };
      }
    },

    setVendorRemittancePaymentReportFilters: (state, action) => {
      const { payload } = action;
      state.vendorRemittancePaymentReportFilters = payload || {};
    },
    resetVendorRemittancePaymentReportFilters: (state) => {
      state.vendorRemittancePaymentReportFilters = {};
    },
    setVendorPayReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.vendorRemittancePaymentReportPageState = {
          ...state.vendorRemittancePaymentReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.vendorRemittancePaymentReportPageState = {
          ...state.vendorRemittancePaymentReportPageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateVendorRemittancePayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVendorRemittancePayment.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorRemittance = data;
        state.totalByVendorRemittance = count;
      })
      .addCase(updateVendorRemittancePayment.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVendorRemittance.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorRemittance.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorRemittance = data;
        state.totalByVendorRemittance = count;
      })
      .addCase(getVendorRemittance.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVendorRemittancePaymentReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorRemittancePaymentReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorRemittancePaymentReport = data;
        if (user) {
          sessionStorage.setItem("vendorPaymentUsers", JSON.stringify(user));
        }
        state.totalByVendorRemittancePaymentReport = count;
      })
      .addCase(getVendorRemittancePaymentReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  resetVendorRemittanceFilters,
  setVendorRemittanceFilters,
  setVendorRemittancePage,

  resetVendorRemittancePaymentReportFilters,
  setVendorRemittancePaymentReportFilters,
  setVendorPayReportPage,
} = vendorRemittanceSlice.actions;

export default vendorRemittanceSlice.reducer;
